// extracted by mini-css-extract-plugin
module.exports = {"editable_2dGL07":"editable_2dGL07","no-editable_3ZaHAU":"no-editable_3ZaHAU"};